const rankingItems = [
  { rank: 1, title: '年度精选热门视频合集', tag: '热播', views: '98.6万', category: '综合精选' },
  { rank: 2, title: '最新高清纪录大片推荐', tag: '新上', views: '87.2万', category: '纪录' },
  { rank: 3, title: '经典影视回顾专场', tag: '经典', views: '76.4万', category: '影视' },
  { rank: 4, title: '综艺爆笑片段集锦', tag: '搞笑', views: '65.8万', category: '综艺' },
  { rank: 5, title: '创意短片精选系列', tag: '创意', views: '58.1万', category: '短片' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            热门排行
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门视频排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时更新最受用户欢迎的高清视频内容
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg font-label font-bold text-lg shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-label font-medium bg-accent-100 text-accent-700 whitespace-nowrap shrink-0">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.category}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-primary-500">{item.views}</p>
                <p className="text-[10px] text-foreground-400">播放量</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}